"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const theme_1 = __importDefault(require("../../styles/theme"));
const uploadDocumentStyles_1 = __importDefault(require("../uploadDocument/uploadDocumentStyles"));
const labelButton_1 = __importDefault(require("../labelButton/labelButton"));
const spinner_1 = __importDefault(require("../spinner/spinner"));
const icon_1 = __importStar(require("../icon/icon"));
const pressableElement_1 = __importDefault(require("../pressables/pressableElement"));
const text_1 = __importStar(require("../text/text"));
const styles_1 = __importDefault(require("../../styles/styles"));
const useAppNavigation_1 = __importDefault(require("../../hooks/useAppNavigation"));
const openExternalLink_1 = __importDefault(require("../openExternalLink/openExternalLink"));
const UploadDocument = ({ setDocument, document, setName = () => { } }) => {
    const [uploading, setUploading] = (0, react_1.useState)(false);
    const navigation = (0, useAppNavigation_1.default)();
    const fileInputRef = react_1.default.createRef();
    const uploadDocument = async (ie) => {
        const file = ie.target.files[0];
        const fileURL = URL.createObjectURL(file);
        setUploading(false);
        setDocument(fileURL);
        setName(file.name);
    };
    const inputFileComponent = react_1.default.createElement("input", { ref: fileInputRef, type: "file", onChange: uploadDocument, hidden: true });
    const pressHandler = () => {
        fileInputRef.current.click();
    };
    const fileName = document ? 'Document' : 'No Statement';
    return (react_1.default.createElement(react_native_1.View, null,
        react_1.default.createElement(react_native_1.View, { style: styles_1.default.centerChildHorizontalVertical },
            react_1.default.createElement(react_native_1.View, { style: uploading ? uploadDocumentStyles_1.default.containerFather : null }, uploading ? (react_1.default.createElement(spinner_1.default, null)) : (react_1.default.createElement(react_native_1.View, null,
                !!document && (react_1.default.createElement(pressableElement_1.default, { style: uploadDocumentStyles_1.default.container, onPress: () => (0, openExternalLink_1.default)({
                        navigation,
                        url: typeof document === 'string' ? document : '',
                        webViewData: {
                            sourcePage: 'upload_doc',
                            sourceScreen: 'upload_doc',
                            name: 'upload_doc',
                            title: 'Uploaded Document',
                        },
                    }), eventName: "view_document" },
                    react_1.default.createElement(react_native_1.View, { style: uploadDocumentStyles_1.default.imageContainer },
                        react_1.default.createElement(icon_1.default, { name: icon_1.FILE_ICON })),
                    react_1.default.createElement(react_native_1.View, { style: uploadDocumentStyles_1.default.fileNameStyle },
                        react_1.default.createElement(react_native_1.View, { style: uploadDocumentStyles_1.default.fileName },
                            react_1.default.createElement(react_native_1.View, null,
                                react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_SUBTITLE }, `${fileName}`)))))),
                react_1.default.createElement(react_native_1.View, { style: uploadDocumentStyles_1.default.twentyVertMargin },
                    inputFileComponent,
                    react_1.default.createElement(labelButton_1.default, { title: "UPLOAD DOCUMENT", onPress: pressHandler, disabled: false, textColor: theme_1.default.colors.COLOR_GREEN_DARK, eventName: "upload_document" }))))))));
};
exports.default = UploadDocument;
